import {RoleModel} from "../../shared/models/role/role.model";

export const customerRole: RoleModel = {
  name: 'customer-role',
  nameDutch: 'Klant',
  employee: {
    view: false,
    add: false,
    edit: false,
    delete: false,
  },
  customer: {
    view: false,
    add: false,
    edit: false,
    delete: false,
    addUser: false,
    editUser: false,
  },
  project: {
    view: true,
    others: false
  },
  firePartition: {
    view: false,
  },
  printQr: {
    view: false,
    generate: true,
  }
}
